const KeenSlider = window.KeenSlider

const { setInitialised, useA11y } = window.BAO.Carousel.plugins

class UspCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.autoplayInterval =
      parseInt(this.getAttribute('autoplay-interval') || '15', 10) * 1000

    this.carousel = this.setupCarousel()
  }

  disconnectedCallback () {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  setupCarousel () {
    const autoplayInterval = this.autoplayInterval

    const autoplayPlugin = (slider) => {
      let mouseOver = false
      const clear = () => {
        clearTimeout(this.timeout)
      }
      const next = () => {
        clearTimeout(this.timeout)
        if (mouseOver) return
        this.timeout = setTimeout(() => {
          slider.next()
        }, autoplayInterval)
      }
      slider.on('created', () => {
        slider.container.addEventListener('pointerenter', () => {
          mouseOver = true
          clear()
        })
        slider.container.addEventListener('pointerleave', () => {
          mouseOver = false
          next()
        })
        slider.container.addEventListener(
          'touchstart',
          () => {
            mouseOver = true
            clear()
          },
          { passive: true },
        )
        slider.container.addEventListener(
          'touchend',
          () => {
            mouseOver = false
            next()
          },
          { passive: true },
        )
        next()
      })
      slider.on('animationEnded', next)
      slider.on('updated', next)
      slider.on('destroyed', clear)
    }

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 16,
        },
        breakpoints: {
          '(min-width: 768px)': {
            disabled: true,
          },
        },
      },
      [setInitialised(), useA11y(), autoplayPlugin],
    )
  }
}

if (!customElements.get('usp-carousel')) {
  customElements.define('usp-carousel', UspCarousel)
}
